import { render, staticRenderFns } from "./AgentOnboarding.vue?vue&type=template&id=ff12664c&"
import script from "./AgentOnboarding.vue?vue&type=script&lang=js&"
export * from "./AgentOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports